import React from 'react';
type FeatureCardProps = {
  image: string;
  title: string;
  description: string;
};
export const FeatureCard: React.FC<FeatureCardProps> = ({ image, title, description }) => {
  return (
    <div className="bg-white rounded-[40px] px-9 py-8 text-center flex flex-col border border-[#531D684D]">
      <img src={image} alt={title} className="rounded-3xl w-full h-80 object-cover mb-5" />
      <h3 className="text-2xl font-bold mb-2">{title}</h3>
      <p className="!leading-[30px] text-lg">{description}</p>
    </div>
  );
};
